import { capitalize } from "@mui/material/utils";
import { unstable_composeClasses, generateUtilityClass } from "@mui/material";
function getUtilityClass(slot) {
  return generateUtilityClass("TrueTypography", slot);
}
function camalize(str) {
  return str.toLowerCase().replace(/[^a-zA-Z0-9]+(.)/g, (_m, chr) => chr.toUpperCase());
}
const useUtilityClasses = (ownerState) => {
  const {
    align = "left",
    gutterBottom,
    noWrap,
    paragraph,
    variant,
    classes,
    noGutter,
    strikethrough,
    highlight,
    color
  } = ownerState;
  const slots = {
    root: [
      "root",
      variant,
      ownerState.align !== "inherit" && `align${capitalize(align)}`,
      gutterBottom && "gutterBottom",
      noGutter && "noGutter",
      noWrap && "noWrap",
      paragraph && "paragraph",
      strikethrough && "strikethrough",
      color && `${camalize(String(color))}`,
      highlight && "highlight"
    ]
  };
  return unstable_composeClasses(slots, getUtilityClass, classes);
};
export {
  getUtilityClass,
  useUtilityClasses
};
//# sourceMappingURL=typography.classes.js.map
